import { useFormikContext } from 'formik';

import Button from 'components/shared/Button/Button';
import Modal from 'components/shared/Modal/Modal';

const UpsertModal = ({
  children,
  open,
  macroTitle,
  loading,
  isEditing,
  className,
  closeHandler
}) => {
  const { submitForm, resetForm } = useFormikContext();

  const title = isEditing ? `Edit ${macroTitle}` : `Create New ${macroTitle}`;

  return (
    <Modal
      isOpen={open}
      handleClose={() => {
        closeHandler?.();
        resetForm();
      }}
      className={className}
      title={title}
      footer={
        <div className="flex w-full items-center justify-between">
          <Button onClick={closeHandler} variant="tertiary" text="Cancel" size="small" />
          <div className="flex items-center gap-x-4">
            <Button text="Reset" variant="tertiary" onClick={resetForm} size="small" />
            <Button
              icon={isEditing ? 'save-mono' : 'add-square-mono'}
              text={isEditing ? 'Update Macro' : 'Create Macro'}
              data-qa="create-new-appointment-macro-btn"
              isLoading={loading}
              onClick={submitForm}
              size="small"
            />
          </div>
        </div>
      }>
      {children}
    </Modal>
  );
};

export default UpsertModal;
